import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router";
import { toast } from 'react-toastify';
import LogoVinet from "../../assets/img/logo1.png";
import { useQuery } from "../../common/hooks/useQuery";
import { DEFAULT_REDIRECT_URI } from '../../constants';
import { activate } from '../../util/APIUtils';
import AuthLayout from "../layout";

const Active = () => {
  const query = useQuery();
  const key = query.get('key');

  const [activating,setActivating] = useState(true)
  const [success,setSuccess] = useState(false);

  useEffect(()=>{
    activate(key).then(activate=>activate.json().then(res=>{
      if(res.id_token){
        toast.success(`Kích hoạt thành công !`)
        setActivating(false);
        setSuccess(true)
        setTimeout(()=>{
          const stringQuery = new URLSearchParams()
          stringQuery.append('token', res.id_token)
          window.location.href = `${DEFAULT_REDIRECT_URI}/redirect?${stringQuery.toString()}`;
        },1000)
      }else{
        toast.error(`Mã kích hoạt không đúng hoặc đã hết hạn!`)
        setActivating(false);
        setSuccess(false)
      }
    }))
  },[])
  if (!key) {
    return <Redirect to={'/'}/>
  }

  return (
    <AuthLayout>
      <div className={'my-10 mx-auto md:my-8 lg:my-14 text-center'}>
        <a href={DEFAULT_REDIRECT_URI} target="_blank">
          <img src={LogoVinet} className=" w-32 mx-auto mb-10" />
        </a>

        <h1 className={'text-primary text-center font-bold text-3xl'}>
          Kích hoạt tài khoản
        </h1>
        <div className="mt-10">
          {activating && activating === true && `Đang kích hoạt tài khoản của bạn ...`}
          {activating && activating === false && success === true &&  `Kích hoạt thành công! Đang chuyển hướng ...`}
          {success === false &&  `Mã kích hoạt không đúng hoặc đã hết hạn`}
        </div>
      </div>
    </AuthLayout>
  );
}

export default Active
